import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import IntervalPlural from 'i18next-intervalplural-postprocessor';
import { initReactI18next } from 'react-i18next';
import de from './de';
import en from './en';
import fr from './fr';
import nl from './nl';

i18n.use(LanguageDetector).use(IntervalPlural).use(initReactI18next).init({
	resources: {
		de: {
			translations: de
		},
		en: {
			translations: en
		},
		fr: {
			translations: fr
		},
		nl: {
			translations: nl
		}
	},
	whitelist: ['de', 'en', 'fr', 'nl'],
	fallbackLng: 'en',
	ns: ['translations'],
	defaultNS: 'translations',
	//allow returning react objects
	returnObjects: true,
	interpolation: {
		escapeValue: false
	}
});

export default i18n;
